import { useExtractionDatasets } from "@/features/data-curation/hooks/useCuration";
import type { ExtractionDataset } from "@/features/data-curation/types";
import { listPaperRepos } from "@/features/repos/api/paperRepos";
import { paperReposListQueryKey } from "@/features/repos/repoQueries";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const groupByRepo = (datasets: ExtractionDataset[] | undefined) => {
  const byRepo = new Map<string, ExtractionDataset[]>();
  for (const dataset of datasets ?? []) {
    byRepo.set(dataset.repo_id, [...(byRepo.get(dataset.repo_id) ?? []), dataset]);
  }
  return byRepo;
};

const createdTime = (iso: string) => Date.parse(iso) || 0;

/** The user's repositories, newest first, with the datasets that each one backs. */
export const useRepositories = () => {
  const repos = useQuery({
    queryKey: paperReposListQueryKey,
    queryFn: listPaperRepos,
    staleTime: 30_000,
  });
  const datasets = useExtractionDatasets({ refetchInterval: 60_000 });
  const list = useMemo(
    () =>
      [...(repos.data ?? [])].sort(
        (a, b) => createdTime(b.created_at) - createdTime(a.created_at),
      ),
    [repos.data],
  );
  const datasetsByRepo = useMemo(() => groupByRepo(datasets.data), [datasets.data]);
  return { list, datasetsByRepo, isLoading: repos.isLoading, isError: repos.isError };
};
